import { createAction } from 'redux-actions';
import {
  REFERENCE_LIST_FETCH,
  REFERENCE_LIST_SUCCESS,
  REFERENCE_LIST_FAILURE,
  DELETE_REFERENCE_FETCH,
  DELETE_REFERENCE_SUCCESS,
  DELETE_REFERENCE_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-REFERENCES--->>>
export const referenceListFetch = createAction(REFERENCE_LIST_FETCH);
export const referenceListSuccess = createAction(REFERENCE_LIST_SUCCESS);
export const referenceListFailure = createAction(REFERENCE_LIST_FAILURE);

export const fetchReferences = () => async dispatch => {
  dispatch(referenceListFetch());
  try {
    const res = await api.get('reference');
    dispatch(referenceListSuccess(res.data));
  } catch (error) {
    dispatch(referenceListFailure(error));
  }
};

//<<<---DELETE-REFERENCE--->>>
export const deleteReferenceFetch = createAction(DELETE_REFERENCE_FETCH);
export const deleteReferenceSuccess = createAction(DELETE_REFERENCE_SUCCESS);
export const deleteReferenceFailure = createAction(DELETE_REFERENCE_FAILURE);

export const deleteReference = (id, lang, callback) => async dispatch => {
  dispatch(deleteReferenceFetch());
  try {
    const res = await api.post(`reference/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteReferenceSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteReferenceFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ReferenceList/actions.js